import { createSelector } from 'reselect';
import BalanceOnHandRouteInfoColumns from '../../containers/BalanceOnHandRouteInfoColumns';
import TableDefinitions from '../../../../../../common/TableDefinitions';

export const getIsLoading = (state) => state.listing.VIEW_BOH_ROUTE_INFO.isLoading;
export const getData = TableDefinitions.VIEW_BOH_ROUTE_INFO.getDataFunction();
export const getColumns = createSelector(getData, BalanceOnHandRouteInfoColumns);
